import { ResearchPerfEvalCriteriaItemForm } from '@/module/ResearchPerfEval/form/ResearchPerfEvalCriteriaItemForm';
import { EvalTemplateCriteriaType } from '@/module/ResearchPerfEval/model/EvalTemplateTypes';
import { useResearchPerfEvalAddCriteriaItem } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';
import { BaseCriteriaItemSchema } from '@/module/ResearchPerfEval/model/ResearchPerfEvalSchema';

import { Id, useAppNotification } from '@feature/utils';

interface ResearchPerfEvalCriteriaItemCreateProps {
  close: () => void;

  evaluationId: Id;
  authorId: Id;
  orderNo: number;

  criteriaType: EvalTemplateCriteriaType;

  dataEntryHint: string | null;

  alreadySelectedIds: number[];
}

const defaultValues = {
  link: '',
  note: '',
  activityDescription: '',
  number: 0,
  file: null,
};

export function ResearchPerfEvalCriteriaItemCreate(props: ResearchPerfEvalCriteriaItemCreateProps) {
  const { close, evaluationId, authorId, orderNo, criteriaType, dataEntryHint, alreadySelectedIds } = props;
  const { mutate, isPending } = useResearchPerfEvalAddCriteriaItem(evaluationId, authorId, orderNo);
  const notification = useAppNotification();

  const onSubmit = (values: BaseCriteriaItemSchema) => {
    mutate(
      {
        ...values,
        item: {
          criteriaType,
          ...values,
        },
      },
      {
        onSuccess: () => {
          notification.success();
          close();
        },
        onError: notification.error,
      },
    );
  };

  return (
    <ResearchPerfEvalCriteriaItemForm
      onCancel={close}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      criteriaType={criteriaType}
      dataEntryHint={dataEntryHint}
      evaluationId={evaluationId}
      authorId={authorId}
      orderNo={orderNo}
      alreadySelectedIds={alreadySelectedIds}
    />
  );
}
